 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		84: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"1":"components-card-card","3":"ibdPage","4":"legacyIbdPage","7":"ad-AdContainer","8":"components-analytics-analytics","9":"components-feature_feed-feature_feed","10":"TwitterIcon","11":"container","12":"fc_executive_board","13":"fc_link-fc_link","14":"post-content-body","15":"aboutUsWpPage","16":"author","17":"category_page","18":"customCollectionPage","19":"fc-components-main-components","20":"feed","21":"loginPage","22":"logoutPage","23":"magazineTagPage","24":"magazine_page","25":"myAccountPage","26":"newsletters_page_marketo","27":"notFoundPage","28":"offerPage","29":"playlistIndexPage","30":"playlistPage","31":"podcastPage","32":"post_page","33":"registerPage","34":"resetPasswordPage","35":"sitemapIndex","36":"sitemapPost","37":"stories","38":"subscribePage","39":"tagPage","40":"videoIndex","41":"videoPage","42":"views-containers-layouts-blank_layout-blank_layout","43":"views-containers-layouts-web_layout-web_layout","79":"MarketoNewsletterForm","80":"MicCarousel","81":"MicIcon","82":"MicMobileIconCarousel","83":"Success-SubmissionSuccess","85":"applications-most-innovative-companies","86":"brands_that_matter_2021","87":"brands_that_matter_page","88":"categoryLink","89":"components-BackgroundHighlight-BackgroundHighlight","90":"components-MultiTabList-MultiTabList","91":"components-QuickCarousel-QuickCarousel","92":"components-StickyBar-StickyBar","93":"components-all_feed-all_feed","94":"components-categories","95":"components-config-config","96":"components-editor_highlights-editor_highlights","97":"components-finite_scroll","98":"components-footer-footer","99":"components-franchise_intro-franchise_intro","100":"components-ibd_category-ibd_category","101":"components-image-image","102":"components-magazine_archive-magazine_archive","103":"components-masthead-masthead","104":"components-mcp_section-mcp_section","105":"components-mic_mobile_menu-mic_mobile_menu","106":"components-more-stories-component-more-stories-component","107":"components-newsletters-recaptcha","108":"components-notice","109":"components-piano-pianoBottomBanner","110":"components-podcast_tile-podcast_tile","111":"components-podcast_tile-podcast_tile_featured","112":"components-post-content-insert","113":"components-ranked","114":"components-recirc-recirc","115":"components-related_posts-related_posts","116":"components-related_slider-related_slider","117":"components-sectors_list-sectors_list","118":"components-social","119":"components-social-social","120":"components-top_50-top_50","121":"components-top_50_shuffle-top_50_shuffle","122":"components-video_megatron-video_megatron","123":"components-video_module-utils-video_module_ads","124":"components-video_module-video_module","125":"containers-pages-list_landers-bwi-2020","126":"containers-pages-list_landers-ibd-2020","127":"containers-pages-list_landers-mic-2021","128":"content-innovation_festival_banner","129":"content-sponsor_bar","130":"fc-components-main-components-StickyBar-StickyBar","131":"fc-components-main-containers","132":"fc-components-main-containers-FranchisePageLayout-FranchisePageLayout","133":"fc-components-main-containers-IbdLayout-IbdLayout","134":"fc-components-main-containers-WciLayout-WciLayout","135":"fc-components-main-utils-ConditionalWrapper","136":"franchises-BtmApplyPage","137":"franchises-BwiApplyPage","138":"franchises-IbdApplyPage","139":"franchises-MicApplyPage","140":"franchises-NbttApplyPage","141":"franchises-WciApplyPage","142":"innovation_by_design_future_page","143":"innovation_by_design_page_franchise","144":"innovation_by_design_page_franchise_2023","145":"layouts","146":"layouts-mcp","147":"nav_main_menu-nav_main_menu","148":"package_article_list_entry","149":"packages-nav-package_sticky_nav","150":"post-content-sidebar"}[chunkId]||chunkId) + "." + {"1":"b6f6d4f904ac6d2997e5","2":"562e190c02cbecb8f68e","3":"5dbfe1cdc0b448055bf5","4":"be20f05ee0c54a8f4784","5":"bc1a28cb9b66b9728d90","6":"64524a4b73378ecfff9e","7":"4cfc9c1e49f4ae343291","8":"135bb87f404749bf27d6","9":"0913d19359355677403e","10":"a1a3cc1c97f45141e1a7","11":"0384994cc847b7766263","12":"e07a6a3c93006a298d39","13":"13d5d7d0eb095d388a19","14":"3aa9d58a7d4ac4e7b125","15":"d8838aedd12da2889dbd","16":"15c40f43594aeaa83b18","17":"a05afab58a6133dcebf2","18":"77c3ed09b17671b14792","19":"f3b20f8a74b8eb01ad05","20":"7a6555688f384877b374","21":"0555c2df5d24b737261b","22":"e267bffd3ec4e5fe7e88","23":"375302d3846072e98815","24":"522940dcc6d6d3a0d328","25":"b74dc6794fc92f1acde9","26":"c4d8986fa72665ce0243","27":"0b314f598b63561e0fc8","28":"8207d5eba6fa1ae5bc37","29":"566b7912567c45c56646","30":"46625f6f2a4564b79a78","31":"395fe85153f7aba564a6","32":"973726db8d9819015831","33":"6eee0e16a22fd3f3ab79","34":"383acff933fda010237b","35":"a3262af8eac7cf45944f","36":"5ab60f76415bbdbebc23","37":"09db22737ddc2b48bf5b","38":"c7220539681c09aa3584","39":"8b52d367e4e6cc70f0e5","40":"c68b8bc7c304bbfcc7bf","41":"473e27e1d83ddb15b5f9","42":"a0c471badc2bda18d922","43":"530d9b4b1a886c6f9d0e","44":"653048c044cfacea173d","45":"fcec24e00aca2c26ffbe","46":"f6a2c0f6b9a62930c719","47":"934ed209be02a5a4e491","48":"71dcf4bd0b76dae92425","49":"3f81cc6bc8cfddab7f12","50":"275bf49510534342763b","51":"eb27fd35abdf56975cea","52":"55c4a649a9c5f123a13e","53":"b6ddac8a5ad8dd3485db","54":"b3e94f149d3208f5686a","55":"d3e6c36c502b1dcc8478","56":"9038ff5b5c46d9f9d6da","57":"962306c0acda10226b98","58":"574ce4920e1538be5ad2","59":"1cb426646dc49be56bef","60":"cb6ec8d6d4b5828f6834","61":"25ff8dbc9739d940441b","62":"ef98945cdcae97e03b10","63":"b752b16d32579982c339","64":"682f823585cfe1edac0e","65":"1099d02f29af1698297d","66":"4c27d2867a7e9735d1ef","67":"658c741fe9c77126b28e","68":"1914791288b3c6912838","69":"e5edb048ad53bc042c58","70":"c037d5cbc4498849a338","71":"f2e8197187b778fa84c3","72":"5c0344b1963889a29de4","73":"b7278e7da20d6343eb59","74":"a74f8a6d1965aa9155b1","75":"1ccd563a2501e5f4535d","76":"110870e0c665116f11ab","77":"2a308ffd6af1a10cbdd5","78":"e724373139fcf154e658","79":"961ef725bc5ef3b55b21","80":"812ce472cdefd0a9b8d2","81":"7c9d5055396d0e664b02","82":"fbc3b064395e3ff1588d","83":"6f7961e984e4e787aafb","85":"360bfedf65c1b1574a67","86":"0242f703dc7a0127d46a","87":"e2b6f8eaf8ae5ab1afe9","88":"e38ba849290f76b20a33","89":"bd107af1dcced43ca1b2","90":"6258f0b54bceb9c8559d","91":"0054f8a0062c917b1feb","92":"8d2e2a538712687fd296","93":"37fad4e45594a0bbdfb1","94":"7c3314e7e86f9b3c41e7","95":"498b094768a6aaadacf0","96":"a0dfa1b368682b3f5b0e","97":"a216b33ccba084d483f5","98":"ac23feee93e4ddaca613","99":"7753cf9fa91c5899860c","100":"d07defe2cd7c972f3ee8","101":"a9141290a6766e507914","102":"bda812ff3353ae7dd19e","103":"9c8d3e57138759bfe617","104":"b5dbbbabf5b2fd52299f","105":"e135bc93ad2a95c4f955","106":"2facf574eb9cb3471dc1","107":"4849145d8c49b89953ed","108":"46252caf612cb71d579d","109":"9a0677c2ed54594dad7d","110":"25b31a8c08243a1d23bc","111":"77f4b291bb677c7eaf4b","112":"d5b4724d1ccb49a36795","113":"12efe28e002522abea4b","114":"630dfc4bbeec73403209","115":"8548193b8cc9befa20ae","116":"74a1a952c3d7e1876973","117":"05d73759d9535afa6bbc","118":"4555cffb9bb2169ad95e","119":"0fbc19cba3076f10c6f1","120":"791e3e410c5858b4cf8c","121":"9cd8121920eceb247712","122":"dd1d56a565d86d0b6a98","123":"dc58690ca05af58e632b","124":"d5b86a4586cbf4ff12f3","125":"bb318159860ddb01e099","126":"10357e74e246248354ea","127":"55c93112992897294fa7","128":"edc540844e03ca0dbb0a","129":"919038b2cfedb09336b1","130":"dfb88799f73bec11b192","131":"7da8c592e5e6ffae02fe","132":"2a640d20f9ea71e06a24","133":"4f92ea0f49850cb17c50","134":"8e096f7a0bfd1186af91","135":"9788ed6476af020b12a6","136":"3c9f042d126e9c3574d5","137":"85547c2e83ea18f8cb6a","138":"abfd41ff207e90bccdb9","139":"5178c53d8bc9ae6dbf35","140":"1afe2d0db89a54f51331","141":"94381e8ef7d05cc98af3","142":"4745bc68ddf365a085e3","143":"4ec6cc1280b28bd6044d","144":"653f0492f5422d69aa8a","145":"e38d950797d4a53049be","146":"2f080d358a9570891e58","147":"1bcd56678f37b5597402","148":"f1a23dea9fad0cbba7a3","149":"5141555c075d27773e0d","150":"7528819ef79f32f4f3ea"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://assets.fastcompany.com/_/fc/bundle/js/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([859,151,0]);
 	// run deferred modules when ready
 	return checkDeferredModules();
